/**
 * Modelo de la publicación de qr
 *
 * @export
 * @class QRDocument
 */

 export class QRDocument {
   documento?: string;
   asunto?: string;
   firmas?: Array<Firmas>;
   vista_firmas?: boolean;
   historial_prestamo?: EstrcuturaBase;
   historial_contenido?: EstrcuturaBase;
   informacion?: EstrcuturaBase;
 }

 export class EstrcuturaBase {
  valores?: any[];
  estructura?: any[];
}

 export class Firmas {
    fucnionario: string;
    accion: string;
  }

  export type tab = 'firmas' | 'prestamo' | 'contenido' ;


  export interface OrdenTabs {
    orden: number;
    pestana: tab;
    requerido: boolean;
    nombre: string;
    modificable?: boolean;
  }


// WEBPACK FOOTER //
// ./src/app/shared/models/qr-document.model.ts